import { useState, useEffect } from "react";
import { useUser } from "../../redux/user";
import { api } from "../../services/api";
import { setLoadingBar } from "../../redux/siteData";
import { FaEnvelope } from "react-icons/fa";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

export default function EmailActivationBanner() {
  const { emailNotActivated, email, id } = useUser();
  const [isVisible, setIsVisible] = useState(true);
  const [isResending, setIsResending] = useState(false);
  const { t } = useTranslation("auth");

  // Reset visibility when emailNotActivated changes to true
  useEffect(() => {
    if (emailNotActivated) {
      setIsVisible(true);
    }
  }, [emailNotActivated]);

  if (!emailNotActivated || !isVisible) {
    return null;
  }

  const handleResend = async () => {
    if (isResending || !id || !email) return;

    setIsResending(true);
    setLoadingBar(true);

    try {
      await api.put(`/users/${id}/email`, { email });
      // Show success message or toast if needed
    } catch (error) {
      console.error("Failed to resend activation email:", error);
    } finally {
      setIsResending(false);
      setLoadingBar(false);
    }
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  return (
    <div className="flex flex-col gap-2 justify-between items-start px-4 py-2 text-sm text-amber-800 bg-amber-50 border-b border-amber-200 sm:flex-row sm:items-center">
      <div className="flex flex-1 gap-2 items-center">
        <FaEnvelope />{" "}
        <Trans
          i18nKey="Please confirm your email address We've sent a verification link to <0>{{email}}</0>"
          values={{ email }}
          components={[<strong />]}
          ns="auth"
        />
      </div>
      <div className="flex gap-3 items-center shrink-0">
        <button
          onClick={handleResend}
          disabled={isResending}
          className="font-medium text-amber-700 underline whitespace-nowrap hover:text-amber-900 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isResending ? t("Sending...") : t("Resend activation email")}
        </button>
        <button
          onClick={handleClose}
          className="text-xl font-medium leading-none text-amber-700 hover:text-amber-900"
          aria-label={t("common:Close")}
        >
          ×
        </button>
      </div>
    </div>
  );
}
